import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "grid-1" }
const _hoisted_2 = {
  key: 0,
  class: "grid-2"
}
const _hoisted_3 = { class: "grid-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = { class: "flex justify-end space-x-3" }

import { computed, ref } from 'vue';

import { ClientResource } from '@shared/resources/client';
import { ClientCreateUpdateDto } from '@shared/dto/client';
import { clientCreateUpdateSchema } from '@shared/validation/client';

import { useValidator } from '@/libs/validator/hooks/use-validator';
import { useEmitter } from '@/plugins/mitt/mitt';
import { ClientService } from '@/services/client.service';

import Label from '@ui-kit/label/Label.vue';
import ValidationKeyObserver from '@components/validation/ValidationKeyObserver.vue';
import SingleLine from '@ui-kit/inputs/single-line/SingleLine.vue';
import MultiLine from '@ui-kit/inputs/multi-line/MultiLine.vue';
import Button from '@ui-kit/controls/button/Button.vue';
import SwitchSection from '@ui-kit/inputs/switch/SwitchSection.vue';
import { ClientType, ClientTypeNameMap } from '@shared/types/client-type';
import { useI18n } from 'vue-i18n';

interface Props {
  data?: ClientResource;
  hideCloseButton?: boolean;
}
interface Emits {
  (type: 'save', value: ClientResource): void;
  (type: 'close'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ManageClientDataForm',
  props: {
    data: null,
    hideCloseButton: { type: Boolean }
  },
  emits: ["save", "close"],
  setup(__props: any, { emit }: { emit: ({
  (type: 'save', value: ClientResource): void;
  (type: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  data?: ClientResource;
  hideCloseButton?: boolean;
}

const emitter = useEmitter();
const clientService = new ClientService();
const { t } = useI18n();





const pending = ref<boolean>(false);
const formData = ref<ClientCreateUpdateDto>({
  type: props.data?.type || ClientType.person,
  name: props.data?.name || '',
  first_name: props.data?.first_name || '',
  last_name: props.data?.last_name || '',
  email: props.data?.email || '',
  phone: props.data?.phone || '',
  address: props.data?.address || '',
  notes: props.data?.notes || '',
});
const validator = useValidator({
  data: formData,
  schema: computed(() => clientCreateUpdateSchema),
});

const typesOptions = [ClientType.person, ClientType.company].map((id) => ({
  id,
  name: t(`common.client-type.${ClientTypeNameMap[id]}`),
}));

function save() {
  if (validator.validate()) {
    function successCallback(client: ClientResource) {
      emit('save', client);
      if (props.data?.id) {
        emitter.emit('updateClient', client);
      } else {
        emitter.emit('addClient', client);
      }
      emit('close');
    }

    pending.value = true;
    if (props.data?.id) {
      clientService
        .update(props.data.id, formData.value)
        .useValidator(validator)
        .send()
        .then((response) => {
          successCallback(response.data);
        })
        .finally(() => {
          pending.value = false;
        });
    } else {
      clientService
        .add(formData.value)
        .useValidator(validator)
        .send()
        .then((response) => {
          successCallback(response.data);
        })
        .finally(() => {
          pending.value = false;
        });
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SwitchSection, {
      options: _unref(typesOptions),
      modelValue: formData.value.type,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.type) = $event))
    }, null, 8, ["options", "modelValue"]),
    (formData.value.type === _unref(ClientType).person)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(Label, {
            label: _ctx.$t('fields.first_name'),
            required: ""
          }, {
            default: _withCtx(({id}) => [
              _createVNode(ValidationKeyObserver, { keys: "first_name" }, {
                default: _withCtx(({firstErrorMessage}) => [
                  _createVNode(SingleLine, {
                    modelValue: formData.value.first_name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.first_name) = $event)),
                    id: id,
                    errors: firstErrorMessage
                  }, null, 8, ["modelValue", "id", "errors"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(Label, {
            label: _ctx.$t('fields.last_name'),
            required: ""
          }, {
            default: _withCtx(({id}) => [
              _createVNode(ValidationKeyObserver, { keys: "last_name" }, {
                default: _withCtx(({firstErrorMessage}) => [
                  _createVNode(SingleLine, {
                    modelValue: formData.value.last_name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.last_name) = $event)),
                    id: id,
                    errors: firstErrorMessage
                  }, null, 8, ["modelValue", "id", "errors"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["label"])
        ]))
      : (_openBlock(), _createBlock(Label, {
          key: 1,
          label: _ctx.$t('fields.name'),
          required: ""
        }, {
          default: _withCtx(({id}) => [
            _createVNode(ValidationKeyObserver, { keys: "name" }, {
              default: _withCtx(({firstErrorMessage}) => [
                _createVNode(SingleLine, {
                  modelValue: formData.value.name,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.name) = $event)),
                  id: id,
                  errors: firstErrorMessage
                }, null, 8, ["modelValue", "id", "errors"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["label"])),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Label, {
        label: _ctx.$t('fields.phone')
      }, {
        default: _withCtx(({id}) => [
          _createVNode(ValidationKeyObserver, { keys: "phone" }, {
            default: _withCtx(({firstErrorMessage}) => [
              _createVNode(SingleLine, {
                modelValue: formData.value.phone,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.phone) = $event)),
                id: id,
                errors: firstErrorMessage
              }, null, 8, ["modelValue", "id", "errors"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(Label, {
        label: _ctx.$t('fields.email')
      }, {
        default: _withCtx(({id}) => [
          _createVNode(ValidationKeyObserver, { keys: "email" }, {
            default: _withCtx(({firstErrorMessage}) => [
              _createVNode(SingleLine, {
                modelValue: formData.value.email,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.email) = $event)),
                id: id,
                errors: firstErrorMessage
              }, null, 8, ["modelValue", "id", "errors"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["label"])
    ]),
    _createVNode(Label, {
      label: _ctx.$t('fields.address')
    }, {
      default: _withCtx(({id}) => [
        _createVNode(ValidationKeyObserver, { keys: "address" }, {
          default: _withCtx(({firstErrorMessage}) => [
            _createVNode(SingleLine, {
              modelValue: formData.value.address,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.address) = $event)),
              id: id,
              errors: firstErrorMessage
            }, null, 8, ["modelValue", "id", "errors"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["label"]),
    _createVNode(Label, {
      label: _ctx.$t('fields.notes')
    }, {
      default: _withCtx(({id}) => [
        _createVNode(ValidationKeyObserver, { keys: "notes" }, {
          default: _withCtx(({firstErrorMessage}) => [
            _createVNode(MultiLine, {
              modelValue: formData.value.notes,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.notes) = $event)),
              id: id,
              errors: firstErrorMessage,
              lines: 6
            }, null, 8, ["modelValue", "id", "errors"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["label"]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      (__props.hideCloseButton)
        ? (_openBlock(), _createBlock(Button, {
            key: 0,
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('close'))),
            size: "lg",
            "button-type": "outline"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.actions.cancel')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(Button, {
        onClick: save,
        size: "lg"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.actions.save')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})